/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encoding greedily subtracts the largest values (M, CM, D, …); decoding adds each symbol, subtracting when a smaller symbol precedes a larger one (e.g. IV = 4).`)
};

const es_rn_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La codificación resta con avidez los valores más grandes (M, CM, D, …); la decodificación suma cada símbolo, restando cuando un símbolo más pequeño precede a uno más grande (p. ej. IV = 4).`)
};

const de_rn_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Kodieren werden gierig die größten Werte abgezogen (M, CM, D, …); beim Dekodieren wird jedes Symbol addiert, wobei subtrahiert wird, wenn ein kleineres Symbol vor einem größeren steht (z. B. IV = 4).`)
};

const nl_rn_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codering trekt greedily de grootste waarden af (M, CM, D, …); decodering telt elk symbool op, aftrekken wanneer een kleiner symbool voorafgaat aan een groter symbool (bijv. IV = 4).`)
};

const fr_rn_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'encodage soustrait avidement les plus grandes valeurs (M, CM, D, …) ; le décodage ajoute chaque symbole, en soustrayant quand un symbole plus petit précède un symbole plus grand (p. ex. IV = 4).`)
};

const it_rn_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La codifica sottrae in modo greedy i valori più grandi (M, CM, D, …); la decodifica aggiunge ogni simbolo, sottraendo quando un simbolo più piccolo precede uno più grande (ad es. IV = 4).`)
};

const pt_br2_rn_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codificação subtrai avidamente os maiores valores (M, CM, D, …); decodificação adiciona cada símbolo, subtraindo quando um símbolo menor precede um maior (ex. IV = 4).`)
};

const pt_rn_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A codificação funciona subtraindo sequencialmente os maiores valores (M, CM, D, …); a descodificação adiciona cada símbolo, subtraindo quando um símbolo menor precede um maior (ex. IV = 4).`)
};

const ja_rn_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エンコーディングは貪欲に最大値(M、CM、D、...)を減算し、デコーディングは各記号を追加し、小さい記号が大きい記号の前にある場合は減算します(例: IV = 4)。`)
};

const zh_rn_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编码时采用贪心算法，每次减去能容纳的最大数值（M、CM、D 等）；解码时则逐个累加符号的值，当较小的符号出现在较大符号之前时则相减（例如 IV = 4）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_faq3_a", locale)
	if (locale === "en") return en_rn_faq3_a(inputs)
	if (locale === "es") return es_rn_faq3_a(inputs)
	if (locale === "de") return de_rn_faq3_a(inputs)
	if (locale === "nl") return nl_rn_faq3_a(inputs)
	if (locale === "fr") return fr_rn_faq3_a(inputs)
	if (locale === "it") return it_rn_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_rn_faq3_a(inputs)
	if (locale === "pt") return pt_rn_faq3_a(inputs)
	if (locale === "ja") return ja_rn_faq3_a(inputs)
	return zh_rn_faq3_a(inputs)
};